import { Button } from "@hr/common/Button";
import { FloppyIcon } from "@hr/common/icons.jsx";
import { getGetCompanyBalancesQueryKey, useBatchUpdateBalances } from "@hr/api/endpoints";
import { manualTabTableQueryKey } from "@hr/statisticsview/vacancy/ManualTab/ManualTab.constants";
import { buildAlert } from "@hr/actions/index.js";
import { useDispatch } from "react-redux";
import { useQueryClient } from "@tanstack/react-query";
import { PersonVacationBalanceJSON } from "@hr/api/model";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Nullable } from "@hr/common/types";
import { UnsavedChangesWarning } from "@hr/common/globaldialogs";
import { useBlocker } from "react-router";
import { ManualTabContext } from "@hr/statisticsview/vacancy/ManualTab/ManualTabContext";

export const ManualTabButtons = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const { mutate, isSuccess } = useBatchUpdateBalances();
  const [iconColor, setIconColor] = useState<Nullable<string>>(null);
  const [openedDialog, setOpenedDialog] = useState<boolean>(false);
  const { editedCellKeys, setEditedCellKeys } = useContext(ManualTabContext);

  const hasChanges = editedCellKeys.size > 0;

  const getIsDataChanged = () => {
    const editedCells: PersonVacationBalanceJSON[] | undefined =
      queryClient.getQueryData([manualTabTableQueryKey, "StoredData"]) || [];
    return editedCells.length > 0;
  };
  const blocker = useBlocker(() => getIsDataChanged());

  const handleSaveChanges = () => {
    const editedCells: PersonVacationBalanceJSON[] | undefined = queryClient.getQueryData([
      manualTabTableQueryKey,
      "StoredData",
    ]);
    if (!editedCells || editedCells.length === 0) {
      return;
    }
    mutate({ data: editedCells });
  };

  const handleDiscard = async () => {
    queryClient.invalidateQueries({ queryKey: getGetCompanyBalancesQueryKey() });
    queryClient.setQueriesData({ queryKey: [manualTabTableQueryKey, "StoredData"] }, []);
    setEditedCellKeys(new Set());
    dispatch(
      buildAlert(
        "SUCCESS",
        t("ImportStatus_SUCCESS", "Onnistui"),
        t("ChangesDiscardedSuccessfully", "Muutokset on hylätty."),
      ),
    );
  };

  const handleSaveSuccess = () => {
    if (isSuccess) {
      queryClient.invalidateQueries({ queryKey: getGetCompanyBalancesQueryKey() });
      queryClient.setQueriesData({ queryKey: [manualTabTableQueryKey, "StoredData"] }, []);
      setEditedCellKeys(new Set());
      dispatch(
        buildAlert(
          "SUCCESS",
          t("ImportStatus_SUCCESS", "Onnistui"),
          t("ItemsUpdatedSuccessfully", "Kohteiden päivitys onnistui."),
        ),
      );
    }
  };

  useEffect(handleSaveSuccess, [isSuccess]);

  useEffect(() => {
    if (blocker.state === "blocked") {
      setOpenedDialog(true);
    }
  }, [blocker]);

  return (
    <>
      <div className="d-flex gap-3">
        {hasChanges && (
          <Button variant="outline-secondary" onClick={handleDiscard}>
            {t("DiscardChanges", "Hylkää muutokset")}
          </Button>
        )}
        <Button
          variant="info"
          onClick={handleSaveChanges}
          onMouseOver={() => setIconColor("#6f42c1")}
          onMouseOut={() => setIconColor(null)}
        >
          <FloppyIcon fill={iconColor} />
          {t("SaveAnnualVacation","Tallenna vuosiloma")}
        </Button>
      </div>
      <UnsavedChangesWarning
        isShow={openedDialog}
        closeAction={() => setOpenedDialog(false)}
        discardAction={handleDiscard}
        saveAction={handleSaveChanges}
        blocker={blocker}
      />
    </>
  );
}; 
